import { SearchSortOrder } from '#server/models';

export const newsSortOrders: SearchSortOrder[] = [
  { title: 'Relevance', type: 'relevance' },
  {
    title: 'Latest',
    type: 'field',
    field: 'relevancy_date',
    order: 'desc',
  },
  {
    title: 'Sort by A - Z',
    type: 'field',
    field: 'sortableTitle',
    order: 'asc',
  },
  {
    title: 'Sort by Z - A',
    type: 'field',
    field: 'sortableTitle',
    order: 'desc',
  },
];
